import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./base/api.service";
import { AbilityDto } from "../dtos/ability.dto";

@Injectable({
    providedIn: 'root',
})
export class AbilitiesService {

    private readonly baseUrl = 'abilities/';

    constructor(private apiService: ApiService) { }

    getAll(): Observable<AbilityDto[]> {
        return this.apiService.get<AbilityDto[]>(this.baseUrl);
    }
}